import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MenuService } from '../../services';
import { Menu } from '../../common/models/menu';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RoutesRecognized,
} from '@angular/router';

@Component({
    selector: 'haven-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuComponent implements OnInit {
  menus;
  event$ 
  public headerText: string = "";
  constructor(public menuService: MenuService, private router: Router) {
    this.event$ = this.router.events
      .subscribe(
        (event) => {
          if (event instanceof NavigationStart) {
            let menu = this.menus.filter(x => x.Url == event.url)[0];
            if (menu) {
              let extraText = menu.DisplayName == "Emails"? "Filed ": "";
              this.headerText = `Recent ${extraText}${menu.DisplayName}`;
            }
          }
        });
  }

  ngOnInit() {
    this.menus = this.menuService.getAllMenus();
    let menu = this.menus.filter(x=>x.Url == this.router.url)[0];
    if(menu){
      let extraText = menu.DisplayName == "Emails"? "Filed ": "";
      this.headerText = `Recent ${extraText}${menu.DisplayName}`;
    }
  }

  ngOnDestroy() {
    this.event$.unsubscribe();
  }
}
